export const navbarMenuMobile = [
  {
    id: 1,
    label: "Beranda",
    pathname: "/efunding",
  },
  {
    id: 2,
    label: "Tentang Kami",
    pathname: "/tentang-kami",
  },
  {
    id: 3,
    label: "Produk Mitra Kami",
    pathname: "#",
    children: [
      {
        label: "Semua Layanan",
        pathname: "/layanan-kami",
      },
      {
        label: "Deposito",
        pathname: "/list-produk-deposito",
      },
      {
        label: "Tabungan",
        pathname: "/list-produk-tabungan",
      },
    ],
  },
  // {
  //   id: 4,
  //   label: "Layanan Kami",
  //   pathname: "/layanan-kami",
  // },
  {
    id: 5,
    label: "Hubungi Kami",
    pathname: "/hubungi-kami",
  },
  {
    id: 6,
    label: "Login",
    pathname: "/login",
  },
  {
    id: 7,
    label: "Daftar",
    pathname: "/register",
  },
];


// WEBPACK FOOTER //
// ./src/utils/navbar_menu_mobile.js